import { requestApi } from '../util/network'

export const upreport =
    (complain_from,complain_content,complain_pic) =>
      requestApi(
        '/Padindex/slh_report',
        'POST',
        {
          complain_from:complain_from,
          complain_content:complain_content,
          complain_pic:complain_pic,
        }
      ) 
